import { isArray, isArrayEmpty } from '../../../utility/helpers';

export const getSubMenuItems = (filters, selectedSubMenu) => {
  return filters.find(filter => filter.id === selectedSubMenu?.id)?.items;
};

export const shouldRenderSubMenu = (selectedSubMenu, subMenuItems) => {
  const hasItems = isArray(subMenuItems) && !isArrayEmpty(subMenuItems);
  if (selectedSubMenu?.isCategorized) {
    return (
      hasItems &&
      subMenuItems.some(
        item =>
          isArray(item[selectedSubMenu.categoryItemsKey]) &&
          !isArrayEmpty(item[selectedSubMenu.categoryItemsKey])
      )
    );
  }

  return hasItems;
};

export const resetFilters = selectedFilters =>
  Object.keys(selectedFilters).reduce((acc, filterKey) => {
    return { ...acc, [filterKey]: [] };
  }, {});

export const isDirty = (selectedFilters = [], tempFilters = []) =>
  selectedFilters.length !== tempFilters.length ||
  tempFilters.some(filter => !selectedFilters.includes(filter));

export const prepareInitialSelectedFilters = (filters, selectedFilters) => {
  return Object.keys(selectedFilters).reduce((acc, filterKey) => {
    return {
      ...acc,
      [filterKey]: selectedFilters[filterKey].filter(filterItem => {
        const filter = filters.find(f => f.id === filterKey);
        if (filter.isCategorized) {
          return filter.items.some(item =>
            item.tags.some(tag => tag.id === filterItem)
          );
        }
        return filter.items.some(item => item.id === filterItem);
      }),
    };
  }, {});
};

export const prepareAllSelectedFilters = (filters, selectedFilters) => {
  return filters.reduce((allFilters, filter) => {
    const selectedFilterItems = selectedFilters[filter.id];
    const hasFilter = selectedFilterItems && !isArrayEmpty(selectedFilterItems);

    if (hasFilter) {
      if (filter.isCategorized) {
        const allCategories = filter.items.reduce(
          (categories, currentCategory) => {
            const tags = currentCategory.tags.filter(tag =>
              selectedFilterItems.includes(tag.id)
            );
            if (!isArrayEmpty(tags)) {
              return [...categories, ...tags];
            }

            return categories;
          },
          []
        );

        if (!isArrayEmpty(allCategories)) {
          return [...allFilters, { ...filter, selectedItems: allCategories }];
        }

        return allFilters;
      }

      return [
        ...allFilters,
        {
          ...filter,
          selectedItems: filter.items.filter(item =>
            selectedFilterItems.includes(item.id)
          ),
        },
      ];
    }

    return allFilters;
  }, []);
};
